<template>
  <VProgressLinear v-bind="$attrs"></VProgressLinear>
</template>

<script>
/**
 * Original Author: Ben Layton
 * Original Team: Fore oh Four!
 */
import { VProgressLinear } from 'vuetify/lib';

export default {
  name: 'NsProgress',
  components: {
    VProgressLinear,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
$purple: map.get(colors.$baseColors, raspberry);
$grey: map.get(colors.$baseColors, eyore);
//@todo - THIS ASSUMES 30px in height
.v-progress-linear__bar__determinate,
.v-progress-linear__background {
  border-radius: 28px;
}
</style>
